import { connect } from 'react-redux';
import appModalActions from '../../store/actions/appModal.action';
import Modal from './Modal';

const mapStateToProps = state => ({
  messageText: state.appModal.messageText,
  messageType: state.appModal.messageType,
  show: state.appModal.show,
  redirect: state.appModal.redirect
});

const mapDispatchToProps = dispatch => {
  return {
    openErrorModal: (message) => dispatch(appModalActions.openErrorModal(message)),
    closeErrorModal: () => dispatch(appModalActions.closeErrorModal()),
    redirectErrorModal: (redirect) => dispatch(appModalActions.redirectErrorModal(redirect))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Modal);
